'use strict';

module.exports = require('./lib/React');



//////////////////
// WEBPACK FOOTER
// ./~/.deno/react@15.7.0/~/react/react.js
// module id = 6
// module chunks = 0